import {createSlice} from "@reduxjs/toolkit";
import { VIEW_MENU_STORAGE_KEY } from "../config/config";
import { load } from "../Utils/Storage";

const savedViewType = load(VIEW_MENU_STORAGE_KEY) ?? 'largeView';

const initialState = {
    viewType: savedViewType,
    sortType: 'a-z',
}

const UISlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setViewType(state, action) {
            state.viewType = action.payload.viewType
        },
        setSortType(state, action) {
            state.sortType = action.payload.sortType
        },
    }
});

export const UIActions = UISlice.actions;
export default UISlice.reducer;
